import Router from "next/router";
import Layout from "../components/Login";
import axios from "axios";
import request from 'superagent'
import { perm, perm_t, perm_data } from "../modules/client/perm";

import { translate } from "react-i18next";

//import {isExpired,isBeforeExpire} from "../libs/expire"
class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      app: ["pis"],
      open: false,
      isBeforeExp:false
    };
  }

   AppExplogout = () =>{
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('activeMenu')
    localStorage.removeItem('theme')
    console.log('Logout...')
    Router.push('/login')
    // window.location.href = `${process.env.SITE_NAME}/login`
    window.location.href = `/login`
  }

  async componentDidMount() {
    
    if(!_.isUndefined(process.env.LICENSE_KEY))
    {
      request
      .get("/api/v1/auth/expire/isexpire")
      .set("Content-Type", "application/json")
      .end(async(err, res) => {
        //console.log(`isExpired = ${res.body.data}`)
        if(res.status == 200)
        {
          if(res.body.data)
             AppExplogout()
          else{

            request
            .get("/api/v1/auth/expire/numofdays/isbefore")
            .set("Content-Type", "application/json")
            .end((err, res) => {
              if(res.status == 200)
              {
                //console.log(`isBeforeExp = ${res.body.data}`)
                this.setState({isBeforeExp: res.body.data})
              }
            })

          }
        }
      })
    }
  

    await perm_data();
    const token = localStorage["token"];

    let empIDStorage = -1;
    if (localStorage["user"] != undefined && localStorage["user"] != null)
      empIDStorage = JSON.parse(localStorage["user"]).employee_id;
    //console.log("empIDStorage = "+empIDStorage)

    if (token == null) {
      Router.push("/login");
    } else {
      const result = await axios
        .get("/api/v1/auth/roles", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "JWT " + token,
          },
        })
        .then((result) => result);

      const apps = result.data.data.apps;
      if (apps != undefined) {
        this.setState({
          app: apps
        });
      }


      await axios
        .get(`/api/v1/auth/roles/user/${empIDStorage}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "JWT " + token,
          },
        })
        .then((rs) => {
          //console.log(`rs.data = ${JSON.stringify(rs.data.data)}`)
          localStorage["userProject"] = process.env.PROJECT;
          if (rs == undefined || rs == null || rs.data.data == "login") {
            Router.push("/login");
          } else {
            if (rs.data.results != undefined && rs.data.results != null) {
              localStorage["userRole"] = rs.data.results.name;
              //console.log("roleName = " + rs.data.results.name)
            }
          }
        });

    }

    await this.setState({
      open: true,
    });
     
  }




  render() {
    const { t } = this.props;
    if (this.state.open) {
      return (
        <Layout
          title="application.select"
          class="page application"
          type="application"
        >

          <ul className="app-select">
            <li className={(this.state.isBeforeExp) ? 'wrapper_expire' : 'hidden'} style={{listStyle: "none"}}>
              {process.env.NODE_ENV === 'production' ? (
                <>
                <p style={{marginBottom:20,fontBold:true}}>{t('app_expire.title_expire')}</p>
                <p>{t('app_expire.detail_hcm_before_exp')}</p>
                <p>{t('app_expire.detail_hcm_please_contact')}</p>
                <p>{t('app_expire.detail_hcm_otherwise')}</p>
                <p style={{marginTop:20,marginBottom:0}}>{t('app_expire.regard_expire')}</p>
                <p>{t('app_expire.hcm_alert_system')}</p>
                </>
              ):(
                <>
                   <p style={{marginBottom:20,fontBold:true}}>{t('app_expire.title_dev')}</p>
                   <p>{t('app_expire.detail_dev')}</p>
                   <p style={{marginTop:20,marginBottom:0}}>{t('app_expire.regard_expire')}</p>
                  <p>{t('app_expire.hcm_alert_system')}</p>
                </>
              )}
            </li>
            <li
              className="item"
              style={{
                display:
                  this.state.app.indexOf("pis") > -1 ? "inline-block" : "none",
              }}
            >

              <a
                href={
                  perm_t(5)
                    ? "/organization/map"
                    : perm_t(4)
                    ? "/benefit/salary/list"
                    : perm_t(3)
                    ? "/employee/list"
                    : perm_t(2)
                    ? "/reports/employment"
                    : perm_t(1)
                    ? "/settings/users/list"
                    : ""
                }
              >
                <img src="/static/images/logo-pis.png" />
                <div className="title">{t("pis_system")}</div>
              </a>
            </li>
            <li
              className="item"
              style={{
                display:
                  this.state.app.indexOf("payroll") > -1
                    ? "inline-block"
                    : "none",
              }}
            >
              {/* {
                process.env.PROJECT !== 'FWD' && process.env.PROJECT !== 'SMTB' ?
                  (
                    <a href="/payroll">
                      <img src="/static/images/logo-payroll.jpeg" />
                      <div className="title">{t('payroll_system')}</div>
                    </a>
                  ) : null
              } */}
            </li>
          </ul>
        </Layout>
      );
    } else {
      return null;
    }
  }
}

export default translate()(Login);

